<template>
  <main class="content container productLoading" v-if="productLoading">
    Загрузка товара
    <img src="../../public/img/Spinner-pink2.svg">
  </main>
  <main class="content container productLoadingFailed productsLoadingFailed" v-else-if="productLoadingFailed">
    <p>Не удалось загрузить товар</p>
    <button @click.prevent="loadProduct">Попробовать еще раз</button>
  </main>

  <main class="content container" v-else>
    <div class="content__top">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link class="breadcrumbs__link" :to="{ name: 'main' }">
            Каталог
          </router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link class="breadcrumbs__link" :to="{ name: 'category', query: { category: category.id }, params: {id: category.id } }">
            {{ category.title }}
          </router-link>
        </li>
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link">
            {{ product.title }}
          </a>
        </li>
      </ul>
    </div>

    <section class="item">

      <div class="item__pics pics">
        <div class="pics__wrapper">
          <img width="570" height="570" :src="srcImg" :alt="product.title">
        </div>
        <div class="pics__list">
          <div class="pics__item" v-for="color in product.colors">
            <img width="98" height="98" :src="color.gallery[0].file.url" :alt="product.title">
          </div>
        </div>
      </div>

      <div class="item__info">
        <span class="item__code">Артикул: {{ product.id }}</span>
        <h2 class="item__title">
          {{ product.title }}
        </h2>
        <div class="item__form">
          <form class="form" action="#" method="POST" @submit.prevent="addToCart">
            <div class="item__row item__row--center">

              <BaseAmount v-model="productAmount" />

              <b class="item__price">
                {{ product.price | numberFormat }} ₽
              </b>
            </div>

            <div class="item__row">
              <fieldset class="form__block">
                <legend class="form__legend">Цвет</legend>
                <div class="colors colors--black">
                  <div class="colors__item" v-for="color in product.colors" :key="color.id">
                    <label class="colors__label">
                      <input class="colors__radio sr-only" type="radio" :value="color.color.id"
                        v-on:click="ChangeImage(color)" v-model.number="checkedColor">
                      <span class="colors__value" :style="{ backgroundColor: color.color.code }">
                      </span>
                    </label>
                  </div>
                </div>
              </fieldset>

              <fieldset class="form__block">
                <legend class="form__legend">Размер</legend>
                <label class="form__label form__label--small form__label--select">
                  <select class="form__select" type="text" name="size" v-model.number="checkedSize">
                    <option :value="size.id" v-for="size in sizes" :key="size.id"> {{ size.title }} </option>
                  </select>
                </label>
              </fieldset>
            </div>


            <button class="item__button button button--primery" type="submit" :disabled="productAddSending">
              В корзину
            </button>

            <div v-show="productAdded">Товар добавлен в корзину</div>
            <div class="preload_productAddSending" v-show="productAddSending">
              <p>Добавляем товар в корзину</p>
              <img src="../../public/img/Spinner-pink2.svg">
            </div>

          </form>
        </div>
      </div>

      <div class="item__desc">
        <ul class="tabs">
          <li class="tabs__item">
            <a class="tabs__link" :class="{ active: activeLink === 1 }"
              @click.prevent="productInfo = true, productDelivery = false, activeLink = 1">
              Информация о товаре
            </a>
          </li>
          <li class="tabs__item">
            <a class="tabs__link" :class="{ active: activeLink === 2 }"
              @click.prevent="productInfo = false, productDelivery = true, activeLink = 2">
              Доставка и возврат
            </a>
          </li>
        </ul>

        <div class="item__content" v-if="productInfo">
          <h3>Состав:</h3>

          <p>
            60% хлопок<br>
            30% полиэстер<br>
          </p>

          <h3>Уход:</h3>

          <p>
            Машинная стирка при макс. 30ºC короткий отжим<br>
            Гладить при макс. 110ºC<br>
            Не использовать машинную сушку<br>
            Отбеливать запрещено<br>
            Не подвергать химчистке<br>
          </p>

        </div>

        <div class="item__content" v-if="productDelivery">
          <h3>Доставка:</h3>

          <p>
            1. Курьерская доставка по Москве и Московской области – 1200 ₽<br>
            2.Самовывоз из магазина. Список и адреса магазинов Вы можете посмотреть здесь<br>
          </p>

          <h3>Возврат:</h3>

          <p>
            Любой возврат должен быть осуществлен в течение Возвраты в магазине БЕСПЛАТНО.<br>
            Вы можете вернуть товары в любой магазин. Магазин должен быть расположен в стране, в которой Вы осуществили
            покупку.
            БЕСПЛАТНЫЙ возврат в Пункт выдачи заказов.<br>
            Для того чтобы вернуть товар в одном из наших Пунктов выдачи заказов, позвоните по телефону 8 800 600 90
            09<br>
          </p>

        </div>

      </div>
    </section>
  </main>
</template>

<script>

import numberFormat from "@/helpers/numberFormat";
import BaseAmount from "@/components/BaseAmount.vue";
import axios from 'axios';
import { API_BASE_URL } from "@/config";
import { mapActions } from "vuex";


export default {
  data() {
    return {
      productAmount: 1,
      productData: null,
      productLoading: false,
      productLoadingFailed: false,
      checkedColor: null,
      checkedSize: null,
      srcImg: null,

      productInfo: true,
      productDelivery: false,
      productAdded: false,
      productAddSending: false,
      activeLink: 1
    }
  },
  components: { BaseAmount },
  filters: {
    numberFormat
  },
  computed: {
    product() {
      return {
        ...this.productData,
      }
    },
    category() {
      return this.productData.category;
    },
    sizes() {
      return this.productData.sizes;
    }
  },
  methods: {
    ...mapActions(['addProductToCart']),
    loadProduct() {
      this.productLoading = true;
      this.productLoadingFailed = false;
      setTimeout(() => {
        axios
          .get(API_BASE_URL + `/api/products/` + this.$route.params.id)
          .then(response => {
            this.productData = response.data,
              this.productData.colors.forEach(color => {
                if (color.color.code == "#ffffff") {
                  color.color.code = "#F0F0F0"
                }
              }),
              this.checkedColor = response.data.colors[0].color.id,
              this.checkedSize = response.data.sizes[0].id,
              this.ChangeImage(response.data.colors[0])
          })
          .catch(() => this.productLoadingFailed = true)
          .then(() => this.productLoading = false);
      }, 3000)
    },
    ChangeImage(color) {
      if (color.gallery != null) {
        this.srcImg = color.gallery[0].file.url;
      } else {
        this.srcImg = null;
      }
    },
    addToCart() {
      this.productAdded = false;
      this.productAddSending = true;
      this.addProductToCart({ productId: this.product.id, colorId: this.checkedColor, sizeId: this.checkedSize, amount: this.productAmount })
        .then(() => {
          this.productAdded = true;
          this.productAddSending = false;
        });
    },
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.loadProduct();
      },
      immediate: true
    }
  },
}

</script>

<style>
.productLoading,
.productLoadingFailed {
  margin: 0 auto;
  width: fit-content;
}

.productLoading img {
  width: 80px;
}

.preload_productAddSending {
  display: flex;
}

.preload_productAddSending img {
  width: 40px;
}

.pics__list {
  align-items: end;
}

.tabs__link:hover {
  color: #222;
  font-weight: 700;
}

.tabs__link:active {
  color: #222;
  font-weight: 700;
}

.tabs__link:active::after {
  bottom: -1px;
  background-color: #e02d71;
}

.active {
  color: #222;
  font-weight: 700;
}

.active::after {
  bottom: -1px;
  background-color: #e02d71;
}

.item__button {
  margin-bottom: 10px;
}
</style>

